import React, { useState, useMemo, useEffect, useContext } from "react";
import Link from "next/link";
import { Container, Col, Row } from "react-bootstrap";
import MainLayout from "../../components/MainLayout/MainLayout";
import twitter from "../../assets/images/twitter.png";
import tikTok from "../../assets/images/tikTok.png";
import client from "../../components/contentful/Contentful";
import ReactPaginate from "react-paginate";
import BetCastCard from "../../components/contentfulBlogs/BetCastCard";
import Head from "next/head";
import { useRouter } from "next/router";
import { appServerSideProps } from "../../utils/getAppService";
import { validateEmail } from "../../utils/Utils";

const BetCast = ({ user }) => {
  const router = useRouter();
  const [blogs, setBlogs] = useState([]);
  const [upcomingEpisodes, setUpcomingEpisodes] = useState([]);
  const [formError, setFormError] = useState();
  const [formSuccess, setFormSuccess] = useState();
  const [email, setEmail] = useState();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const onSubmitClick = async (e) => {
    setFormError();
    e.preventDefault();

    if (!email || email == "") {
      setFormError("Please enter an email");
      return;
    }
    if (!validateEmail(email)) {
      setFormError("Email is not valid");
      return;
    }
    fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/klaviyo/betcast/${email}/save`)
      .then((res) => {
        if (res.status === 200) {
          setButtonDisabled(true);
          setFormSuccess("Request has been sent successfully!");
          setFormError("");
        } else {
          setFormError("An error occurred. Please try again");
        }
      })
      .catch((err) => {
        console.error("err", err);
        setFormError("An error occurred. Please try again");
      });
  };
  useEffect(() => {
    // 2024-04-30T19:00-04:00
    const today = new Date();
    const getPost = async () => {
      const res = await client.getEntries({
        content_type: "betCast",
        order: "-fields.episodeDate",
      });
      const futurePosts = res.items.filter((post) => {
        const postDate = new Date(post.fields.episodeDate);
        return postDate > today;
      });
      const pastPosts = res.items.filter((post) => {
        const postDate = new Date(post.fields.episodeDate);
        return postDate <= today;
      });
      setBlogs(pastPosts);
      setUpcomingEpisodes(futurePosts);
    };
    getPost();
  }, []);

  const recordsPerPage = 10;
  const [pageCount, setPageCount] = useState(0);
  const [startItemIndex, setStartItemIndex] = useState(0);

  const currentItems = useMemo(() => {
    if (blogs && blogs?.length !== 0) {
      setPageCount(Math.ceil(blogs.length / recordsPerPage));
      const endItemIndex = startItemIndex + recordsPerPage;
      return blogs.slice(startItemIndex, endItemIndex);
    } else {
      return blogs;
    }
  }, [blogs, startItemIndex]);

  const handlePageClick = (event) => {
    const newStartIndex = (event.selected * recordsPerPage) % blogs.length;
    setStartItemIndex(newStartIndex);
  };

  const handleNext = () => {
    if (startItemIndex + recordsPerPage < blogs.length) {
      setStartItemIndex(startItemIndex + recordsPerPage);
    }
  };
  const handlePrev = () => {
    if (startItemIndex - recordsPerPage >= 0) {
      setStartItemIndex(startItemIndex - recordsPerPage);
    }
  };

  return (
    <>
      <Head>
        <title>Basketball Live Betting Odds, Lines, and Analysis - BetCast</title>
        <meta
          name="description"
          content={
            "Tune in to BetCast to see how live regression data can power your live NCAA, NBA, and WNBA picks and predictions."
          }
        />
        <meta property="og:title" content={"Basketball Live Betting Odds, Lines, and Analysis - BetCast"} />
        <meta
          property="og:description"
          content={
            "Tune in to BetCast to see how live regression data can power your live NCAA, NBA, and WNBA picks and predictions."
          }
        />
        <meta property="og:url" content={`https://shotqualitybets.com/betcast  `} />
      </Head>
      <MainLayout>
        <div style={{ backgroundColor: "white" }}>
          <Container className="pb-5 p-4" style={{ maxWidth: "1320px" }}>
            <Row style={{ paddingTop: "50px" }}>
              <Col md={12}>
                <h1>
                  <span className="color-orange">BetCast </span> -{" "}
                  <span style={{ fontSize: "2.2rem" }}>The only live betting show using in-game regression data</span>
                </h1>
                <p>
                  Tune in as your hosts Justin Perri, Alec Musa, and special guests use ShotQuality's ScoreCenter to
                  power their live picks and predictions. ScoreCenter unlocks ShotQuality's live regression data which
                  is proven to be more predictive.
                </p>
              </Col>
              <div className="col-10"></div>
              <Col md={2} style={{ display: "flex", justifyContent: "end", gap: "1rem" }}>
                <div style={{ width: "34px", height: "34px" }}>
                  <Link href="https://twitter.com/shotqualitybets?lang=en" target={"blank"}>
                    <img src={twitter.src} className="SocialIconImg" alt="Twitter" />
                  </Link>
                </div>
                <div style={{ width: "34px", height: "34px" }}>
                  <Link href="https://www.tiktok.com/@shotqualitybets" target={"blank"}>
                    <img src={tikTok.src} className="SocialIconImg" alt="TikTok" />
                  </Link>
                </div>
              </Col>
              <div className="col-12 p-4 pb-4 mt-4 black-blue-gradient">
                <h2 className="text-white mb-3">
                  BE THE FIRST TO KNOW WHEN BETCAST IS <span className="blink color-orange">LIVE</span>
                </h2>
                <form
                  action="#"
                  className=""
                  style={{
                    display: "flex",
                    gap: "2rem",
                    alignItems: "start",
                    flexWrap: "wrap",
                  }}
                >
                  <input
                    type="email"
                    placeholder="Enter your Email"
                    className="input outline"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    style={{ minWidth: "20rem" }}
                    onChange={handleEmailChange}
                    value={email}
                  />
                  <button className="btn btn-orange p-10-15" onClick={onSubmitClick} disabled={buttonDisabled}>
                    Add Me to the List
                  </button>
                </form>
                <div className="position-relative w-100 text-left mt-3">
                  {formError ? <p className="wrongDetails mb-0 p-0">{formError}</p> : <></>}
                  {formSuccess ? <p className={"formSuccess mb-0 p-0"}>{formSuccess}</p> : <></>}
                </div>
              </div>
            </Row>
            <div className="row mt-5">
              <h2 className="pb-3">Upcoming Episodes</h2>
              {upcomingEpisodes && upcomingEpisodes.length > 0 ? (
                upcomingEpisodes.map((post, index) => (
                  <div key={"blog" + index} className="col-12 col-sm-12 pb-4">
                    <BetCastCard post={post} user={user} isFuture={true} />
                  </div>
                ))
              ) : (
                <h5 className="text-center pt-5 w-100">No Upcoming Episodes Found!</h5>
              )}
            </div>
            <hr className="mt-5" />
            <div className="row mt-5 pt-4">
              <h2 className="pb-3">Past Episodes</h2>
              {currentItems && currentItems.length > 0 ? (
                currentItems.map((post, index) => (
                  <div key={"blog" + index} className="col-12 col-sm-12 pb-4">
                    <BetCastCard post={post} user={user} isFuture={false} />
                  </div>
                ))
              ) : (
                <h5 className="text-center pt-5 w-100">No Past Episodes Found</h5>
              )}
            </div>

            {blogs?.length > recordsPerPage && (
              <>
                <div className="hidden">
                  <ReactPaginate
                    className="articlePagination"
                    activeClassName="activePage"
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={0}
                    pageCount={pageCount}
                    previousLabel="<"
                    renderOnZeroPageCount={null}
                  />
                </div>
                <div className="float-right">
                  <button className="btn btn-primary mr-3" disabled={startItemIndex == 0} onClick={handlePrev}>
                    Prev
                  </button>
                  <button
                    className="btn btn-primary"
                    disabled={startItemIndex + recordsPerPage > blogs.length}
                    onClick={handleNext}
                  >
                    Next
                  </button>
                </div>
              </>
            )}
          </Container>
        </div>
      </MainLayout>
    </>
  );
};

export const getServerSideProps = appServerSideProps(async ({ appService, cookies, params, query }) => {
  const isUserLogged = appService.getUser();
  let user = null;
  if (isUserLogged) {
    user = await appService.get("api/account");
  }

  return {
    props: {
      user,
    },
  };
});
export default BetCast;
